module.exports = __webpack_public_path__ + "static/media/image_5.cd3ff2ee.jpg";